import type { RouteLocationRaw } from 'vue-router'

export function useContentUrl(doc: MaybeRefOrGetter<any>): ComputedRef<RouteLocationRaw | undefined> {
  const hasLicense = useHasLicense()

  return computed<RouteLocationRaw | undefined>(() => {
    const document = toValue(doc)

    if (!hasLicense.value) {
      if (document.nodeType === 'book') {
        return { name: 'book-about-by-id', params: { bokId: document.id } }
      }
      if ((document.nodeType === 'journal_article' || document.nodeType === 'journal_editorial') && 'publisherId' in document && document.publisherId) {
        return { name: 'journal-publication', params: { publisherId: [document.publisherId] } }
      }
    }

    return resolveSolrDocumentUrl(document)
  })
}
